import { Container, Grid, Paper } from '@material-ui/core'
import React from 'react'
import { components, useTranslation } from 'cng-web-lib'

import CompanyForShipperRequestViewForm from './CompanyForShipperRequestViewForm'
import CompanyShipperRequestTypeCrudTable from './CompanyShipperRequestTypeCrudTable'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import CompanyForShipperRequestKeys from 'src/constants/locale/key/CompanyForShipperRequest'

const { CngTabs } = components


function ViewPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.COMPANY_FOR_SHIPPER_REQUEST])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let companyForShipperRequest = translate(
      Namespace.COMPANY_FOR_SHIPPER_REQUEST,
      CompanyForShipperRequestKeys.TITLE
    )
    let companyShipperRequestType = translate(
      Namespace.COMPANY_FOR_SHIPPER_REQUEST,
      CompanyForShipperRequestKeys.CompanyShipperRequestType.TITLE
    )

    return {
      companyForShipperRequest,
      companyShipperRequestType
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <CompanyForShipperRequestViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={(datum) => {console.log("CompanyForShipperRequest View Form")}}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.companyForShipperRequest,
              tabContent: (
                <CompanyForShipperRequestViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
            {
              tabName: translatedTextsObject.companyShipperRequestType,
              tabContent: (
                <CompanyShipperRequestTypeCrudTable
                  showNotification={showNotification}
                  companyForShipperRequestId={id}
                  isViewOnly={true}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage